<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col md="5">
        <v-stepper v-model="step" alt-labels>
          <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1">
              약관 동의
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="step > 2" step="2">
              가입 양식 작성
            </v-stepper-step>

            <v-divider></v-divider>
            <v-stepper-step :complete="step === 3" step="3">
              가입 완료
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" class="pa-0">
              <agreement @complete="step = 2"></agreement>
            </v-stepper-content>
            <v-stepper-content step="2" class="pa-2">
              <v-row class="justify-center">
                <v-col cols="12">
                  <v-card outlined>
                    <v-card-title class="justify-center">
                      <span>회원가입</span>
                    </v-card-title>
                    <v-card-text>
                      <v-form ref="form" autocomplete="off" lazy-validation>
                        <v-row>
                          <v-col cols="8">
                            <v-text-field
                              :disabled="validationFlags.disableField"
                              :rules="[rules.required, rules.isUserId]"
                              label="ID"
                              v-model="inptData.id"
                              dense
                              outlined
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="4" class="align-self-center">
                            <v-btn
                              outlined
                              class="default-btn"
                              block
                              @click="checkId"
                              >중복확인</v-btn
                            >
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              ref="passInput"
                              :rules="[
                                rules.required,
                                rules.isPw,
                                rules.notEquals(
                                  inptData.id,
                                  inptData.password,
                                  'ID와 일치합니다.'
                                )
                              ]"
                              type="password"
                              label="비밀번호"
                              v-model="inptData.password"
                              dense
                              outlined
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              ref="passConfirmInput"
                              :rules="[
                                rules.required,
                                rules.isPw,
                                rules.equals(
                                  inptData.passwordConfirm,
                                  inptData.password,
                                  '비밀번호가 일치하지 않습니다.'
                                )
                              ]"
                              type="password"
                              label="비밀번호 재확인"
                              v-model="inptData.passwordConfirm"
                              dense
                              outlined
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              ref="nameInput"
                              :rules="[rules.required]"
                              label="이름"
                              v-model="inptData.name"
                              dense
                              outlined
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              ref="emailInput"
                              :rules="[rules.required, rules.isEmail]"
                              label="이메일"
                              v-model="inptData.email"
                              dense
                              outlined
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                          <phone-certificate
                            :create-type="true"
                            @isCertificateOk="updatePhoneNumber"
                          ></phone-certificate>
                          <v-row class="px-4">
                            <v-col>
                              <v-btn
                                outlined
                                class="default-btn"
                                block
                                @click="step = 1"
                                >뒤로가기</v-btn
                              >
                            </v-col>
                            <v-col>
                              <v-btn
                                outlined
                                class="default-btn"
                                block
                                @click="join"
                                >가입하기</v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-row>
                      </v-form>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-container fluid>
                <v-row>
                  <p>축하합니다.</p>
                  <p>가입이 완료 되었습니다.</p>
                  <p>가입하신 아이디는 {{ inptData.id }} 입니다.</p>
                </v-row>
                <v-row>
                  <v-btn outlined class="default-btn" block link to="/login">
                    로그인 페이지로 이동</v-btn
                  >
                </v-row>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import store from '@/store'
import { registUserDataChk } from '@/api/common/user'
import Message from '@/utils/message'
import irules from '@/utils/rules'
import Agreement from '@/layout/components/Agreement'
import PhoneCertificate from '@/layout/components/PhoneCertificate'

export default {
  name: 'Regist',
  components: {
    PhoneCertificate,
    Agreement
  },
  data() {
    return {
      step: 1,
      // 사용자 입력 데이터
      checkPhone: true,
      rules: irules,
      inptData: {
        id: '',
        password: '',
        passwordConfirm: '',
        name: '',
        phoneNumber: '',
        fromPhoneNumber: '1566-1566',
        email: ''
      },
      idValidateCheck: false, // 아이디 중복체크 여부
      isCertificateOk: false, // 인증 성공 유무
      validationFlags: {
        disableField: false // 아이디, 이름 변경불가
      },
      initFlag: false,
      // validation false 일 때 메시지 초기값들
      // 팝업 호출을 위한 변수
      popup: {
        // 에러 팝업 호출
        error: {
          ok: false, // 팝업 호출여부 true이면 호출됨
          message: '' // 팝업에 표시할 메시지
        },
        // 컨펌 팝업 호출(버튼은 확인 버튼 한개)
        confirm: {
          ok: false, // 팝업 호출여부 true이면 호출됨
          message: '' // 팝업에 표시할 메시지
        }
      },
      popupWidths: {
        widthM: 'w-4/5',
        widthLg: 'w-2/5',
        widthXl: 'w-1/3'
      }
    }
  },
  created: () => {},
  mounted: function() {},
  // computed 가 아닌 watch 를 쓰는 이유는 computed 내부에 dataSet이 들어가면 안됨
  computed: {},
  watch: {
    'inptData.id': function() {
      this.idValidateCheck = false
    }
  },
  methods: {
    updatePhoneNumber(value) {
      this.isCertificateOk = true
      this.inptData.phoneNumber = value
    },
    checkId() {
      registUserDataChk(this.inptData.id).then(res => {
        if (res.body) {
          const message = '중복된 아이디 입니다.'
          // 아이디 중복 체크 후 동일한 아이디가 존재하면 에러 팝업 띄움
          Message.err(message)
        } else {
          Message.info('이용가능한 아이디 입니다.')
          this.idValidateCheck = true
        }
      })
    },
    join() {
      if (!this.idValidateCheck) {
        Message.err('아이디 중복확인이 누락됐습니다.')
        return
      }
      if (!this.$refs.form.validate()) {
        if (!this.$refs.passInput.validate()) {
          Message.err('비밀번호 양식이 올바르지 않습니다.')
          return
        }
        if (!this.$refs.passConfirmInput.validate()) {
          Message.err('비밀번호 확인이 일치하지 않습니다.')
          return
        }
        if (!this.$refs.nameInput.validate()) {
          Message.err('이름 입력은 필수 입니다.')
          return
        }
        if (!this.$refs.emailInput.validate()) {
          Message.err('Email 입력란을 확인해주세요.')
          return
        }
        return
      }
      if (!this.isCertificateOk) {
        Message.err('휴대전화 인증절차가 누락됐습니다.')
        return
      }

      var saveData = {
        user_id: this.inptData.id,
        kor_nm: this.inptData.name,
        phone: this.inptData.phoneNumber,
        password: this.inptData.password,
        email: this.inptData.email,
        company: 'HHI'
      }
      store
        .dispatch('RegistUser', saveData)
        .then(response => {
          // 회원가입 성공시 인증 API에 필요했던 세션 제거
          store.dispatch('ClearSession')
          // 회원가입 성공시 팝업 띄움
          // 팝업 종료 후 로그인 페이지로 이동
          this.step = 3
        })
        .catch(reject => {
          Message.err('가입에 실패했습니다. 잠시후 다시 시도해주세요.')
        })
    },
    // 뒤로가기
    back() {
      this.$router.go(-1)
    },
    // 가입이 완료되면 로그인 화면으로 돌아간다.
    goLoginPage() {
      // 회원가입 창으로 돌아가지 않기 위해 replace 사용
      // push 사용시 쿠키가 남아 뒤로가기가 가능하다.
      this.$router.replace('/login')
    },
    // 팝업을 닫는 함수
    popupRes(result) {
      this.popup[result.id].ok = false
      // 컨펌 메시지일때는 로그인 페이지로 이동한다.
      if (result.id === 'confirm') {
        this.goLoginPage()
      }
    }
  }
}
</script>

<style scoped></style>
